import { trustItems } from "@/config/trust";
import { localizePath, useI18n } from "@/i18n";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function TrustStrip() {
  const { t, locale } = useI18n();
  const localizedItems = getMarketingCopy(locale)?.trustItems;
  const items = trustItems.map((item) => ({
    ...item,
    ...(localizedItems?.find((localized) => localized.id === item.id) ?? {}),
  }));

  if (!items.length) return null;

  return (
    <section aria-label={t.trust.title} className="border-b border-border bg-card">
      <div className="container-page py-12 lg:py-14">
        <p className="eyebrow">{t.trust.eyebrow}</p>
        <h2 className="display-3 mt-3 max-w-2xl text-balance">{t.trust.title}</h2>

        <ul
          className={`mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 ${
            items.length >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"
          }`}
        >
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id} className="min-w-0">
                <span className="grid size-11 place-items-center rounded-full bg-accent/10 text-accent ring-1 ring-accent/25">
                  <Icon className="size-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-[0.95rem] font-semibold tracking-tight text-foreground">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
              </li>
            );
          })}
        </ul>

        <p className="mt-10 text-sm leading-relaxed text-muted-foreground">
          {t.trust.guaranteeMention}{" "}
          <a
            href={`${localizePath("/about", locale)}#guarantee`}
            className="font-medium text-foreground underline-offset-4 hover:underline"
          >
            {t.trust.guaranteeLink}
          </a>
        </p>
      </div>
    </section>
  );
}
